import { BasicRequest } from "./basicRequest";

export class PublishFileDefinitionRequest extends BasicRequest{
    public fileDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}